import { Row, Table } from '@tanstack/react-table';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomToolbarAction } from '@work4all/components/lib/dataDisplay/actions-bar/ToolbarTypes';
import ProjectPlanningIcon from '@work4all/components/lib/icons/ProjectPlanningIcon';

import { useNavigate } from '@work4all/data/lib/hooks';

export enum PROJECTPLANNINGACTIONS {
  openInFullscreen = 'openInFullscreen',
}

export const useProjectPlanningActions = ({
  table,
}: {
  table: Table<unknown>;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const selectedFlatRows = table.getSelectedRowModel().flatRows;

  const open = useCallback(
    (selectedIds: string[]) => {
      const link = `/more/project-planning?layout=${
        selectedIds.length > 1 ? 'stacked' : 'gantt'
      }&projectIds=${selectedIds.join(',')}`;
      navigate(link);
    },
    [navigate]
  );

  const handleOpenClick = useCallback(() => {
    const ids = getSelectedRowIds(selectedFlatRows);
    open(ids);
  }, [open, selectedFlatRows]);

  const planCalendarActionDefinitions: CustomToolbarAction[] =
    useMemo((): CustomToolbarAction[] => {
      return [
        {
          actionKey: PROJECTPLANNINGACTIONS.openInFullscreen,
          IconComponent: ProjectPlanningIcon,
          title: t(
            selectedFlatRows?.length === 1
              ? 'PROJECT_PLANNING.LAYOUT.gantt'
              : 'COMMON.PROJECTPROCESS_other'
          ),
          disabled: false,
          handler: () => {
            handleOpenClick();
          },
          mode: 'Add',
        },
      ];
    }, [t, selectedFlatRows?.length, handleOpenClick]);
  return { open, planCalendarActionDefinitions };
};

function getSelectedRowIds(rows: Row<unknown>[]): string[] {
  return rows
    .filter((row) => !row.getIsGrouped())
    .map((row) => (row.original as { id: string })?.id);
}
